<script lang="ts">
  import type { Platform } from '../../shared/types';
  import { hueOf, initials } from '../ui';

  interface Props {
    name: string;
    url?: string;
    platform?: Platform;
    size?: number;
  }

  let { name, url, platform, size = 48 }: Props = $props();
</script>

<div
  class="avatar"
  style:width={`${size}px`}
  style:height={`${size}px`}
  style:font-size={`${Math.round(size * 0.36)}px`}
  style:background={url ? undefined : `hsl(${hueOf(name)} 48% 34%)`}
>
  {#if url}
    <img src={url} alt="" loading="lazy" />
  {:else}
    <span>{initials(name)}</span>
  {/if}
  {#if platform}
    <i class={`platform-dot ${platform}`} title={platform}></i>
  {/if}
</div>
